import { useRosterFocusStore } from "@/store/rosterFocusStore";

function TdSummaryPerNurse({ code, count }: { code: string; count: number }) {
  const columnKey = `shift${code}`;
  const isHovered = useRosterFocusStore((s) => s.hoveredColumn === columnKey);
  const isSelected = useRosterFocusStore((s) => s.selectedColumn === columnKey);
  const setHoveredFocus = useRosterFocusStore((s) => s.setHoveredFocus);
  const clearHoveredFocus = useRosterFocusStore((s) => s.clearHoveredFocus);

  const highlightBg = isSelected
    ? "rgba(169, 223, 254, 0.4)"
    : isHovered
      ? "rgba(169, 223, 254, 0.3)"
      : undefined;

  return (
    <div
      className="rt_cell flex h-[34px] shrink-0 items-center justify-center"
      style={{
        width: "var(--shiftCode_size)",
        ...(highlightBg != null ? { backgroundColor: highlightBg } : {}),
      }}
      data-column={columnKey}
    >
      <div
        className="flex size-7 items-center justify-center rounded-sm border text-center text-sm font-normal leading-none tabular-nums text-zinc-500"
        onMouseEnter={() => {
          setHoveredFocus({ column: columnKey, nurseId: "" });
        }}
        onMouseLeave={() => {
          clearHoveredFocus();
        }}
      >
        {count}
      </div>
    </div>
  );
}

export default TdSummaryPerNurse;
